import 'react-quill/dist/quill.snow.css'
import React, { useCallback, useEffect, useState } from 'react'
import { deleteManagerAPI, sentimentAPI } from 'api'
import ChatChannelWallActionDetail from './ChatChannelWallActionDetail'
import { usersHelpers, getFormatedDate } from '../../../../utils'
import { getChannelKey } from 'constants/channels'
import DisplayNameMsg from '../../DisplayNameMsg'
import ChatChannelWallMessagesPlugins from '../ChatChannelWallMessagesPlugins'
import Attachment from '../../Attachment'
import ActivityMsg from '../../ActivityMsg'
import InReplyTo from '../../InReplyTo'
import { getStaticImage } from 'utils/statics'
import { MenuDotsOptions, UserAvatar } from 'components/common'
import { lang } from 'utils/helpers'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { updateNode } from 'redux/actions/wall'
import './styles.scss'
import onDownloadMultipleFilesToZip from 'utils/downloadMultipleFilesToZip'
import onDownloadMultipleFiles from 'utils/downloadMultipleFiles'
// import '../../ChatChannels/ChatChannelMessage/styles.scss'

const CHANNELS_WITHOUT_NODES = ['chatweb', 'android', 'ios']

const ChatChannelWallNodeInfo = ({ user, operator, isChat, node, activitiesTypes }) => {
  const wallSettings = {
    paddingType: 'paddingLeft',
    comments: {
      limit: 3,
    },
  }

  const dispatch = useDispatch()

  /* Do not show nodes comments, likes, etc for ChatWeb, Android and iOS */
  const notDiplayChild = isChat || CHANNELS_WITHOUT_NODES.includes(user.channels[0].channel)

  const [isShowComments, setIsShowComments] = useState(false)
  const [isShowLinkMoreComments, setIsShowLinkMoreComments] = useState(false)
  const [isOpenMessageOptionsSelector, setIsOpenMessageOptionsSelector] = useState({})
  const [isOpenRemoveModal, setIsOpenRemoveModal] = useState(false)

  const checkNodeExceedsCommentsLimit = useCallback(
    (acc, { actionDetailList }) => {
      if (!acc && Array.isArray(actionDetailList)) {
        return actionDetailList.length >= wallSettings.comments.limit ? true : actionDetailList.reduce(checkNodeExceedsCommentsLimit, acc)
      }
      return acc
    },
    [wallSettings.comments.limit]
  )

  useEffect(() => {
    setIsShowLinkMoreComments(node.actionDetailList.reduce(checkNodeExceedsCommentsLimit, false))
  }, [node.actionDetailList, checkNodeExceedsCommentsLimit])

  const renderAttachments = (contentURL = '') => {
    if (contentURL.length <= 0) return

    const attachments = []
    try {
      if (contentURL) {
        attachments.push(
          <div
            key='message-attachments'
            className={`message-attachments new-size-font ${contentURL.length > 1 ? 'message-attachments--multiple' : ''}`}
          >
            {contentURL.map((a, k) => {
              const { mime, mimeType = '', mimeSubtype = '', fileId = '' } = a
              const aMime = mime ? mime.split('/') : [mimeType, mimeSubtype]
              return (
                <Attachment
                  key={`${fileId}-${k}`}
                  id={`attachment-${k}-${fileId}`}
                  url={a.urlLong || a.url}
                  mimeType={aMime[0]}
                  mimeSubtype={aMime[1]}
                  shortUrl={a.url || a.shortUrl}
                  thumb={a.thumb}
                  withVirus={a.withVirus}
                />
              )
            })}
          </div>
        )
      }
    } catch (error) {
      return null
    }
    return attachments
  }

  const getCommentClassName = (isShowComments, index, wallSettings) => (!isShowComments && index + 1 >= wallSettings.comments.limit ? 'hide' : 'show')

  if (activitiesTypes.includes(node.type)) {
    return (
      <ActivityMsg
        id={node._id}
        avatar={node.postedBy?.photoURL}
        name={node.postedBy?.name || node.postedBy?.email}
        activityData={{
          type: node.type,
          text: node.messageContent.messageText,
          insertBy: node.insertBy,
          metadata: node.metadata,
          assignedTo: node.assignedTo,
          state: node.state,
          brandName: node.brandName,
          delegationName: node.delegationName,
          date: node.updatedAt,
          urlVisited: node.urlVisited ? node.urlVisited : ''
        }}
      />
    )
  }

  const getTextFromAudio = (files) => {
    let texts = ''
    if (files.length) {
      files.forEach(it => {
        if (it.mimeType === 'audio' && it.text) {
          texts = texts + '[' + it.text + ']'
        }
      })
    }
    return texts
  }

  const toggleMessageOptionsSelector = ({ id }) => {
    if (id) {
      setIsOpenMessageOptionsSelector(prevState => ({ ...prevState, [id]: !prevState[id] }))
    } else {
      setIsOpenMessageOptionsSelector({})
    }
  }

  const handleDeleteMessageOption = () => {
    toggleMessageOptionsSelector({})
    setIsOpenRemoveModal(true)
  }

  const handleDeleteMessage = async (message) => {
    try{
      const data = {
        userId: message.user,
        messageId : message._id
      }
      const response = await deleteManagerAPI.deleteComment(data)
      if(response.data?.success)
        dispatch(updateNode({ ...message, actionDetailList:[], messageContent:{ ...message.messageContent, messageText:'message_delete', attachments:[], buttons:[] }, isRemoved: true }))
    }catch(error){
      toast(lang('error_message_delete'), { position: 'top-right' })
    }
  }

  const toggleDotsOptions = (e) => {
    if(e === undefined) toggleMessageOptionsSelector({ })
    else{
      e.stopPropagation()
      toggleMessageOptionsSelector({ id: user._id })
    }
  }

  const getMenuSelectorOptions = () => {
    const { type, messageContent } = node
    const { attachments } = messageContent
    const options = []
    if (type === "operator") {
      options.push({
        id:'delete',
        name: lang('dashboard_delete'),
        onClick: handleDeleteMessageOption
      })
    }
    if (attachments?.length) {
      if (attachments.length === 1) {
        options.push({
          id:'download',
          name: lang('dashboard_download_attachment'),
          onClick: () => onDownloadMultipleFiles({ urls: attachments.map(it => it.urlLong || it.url) })
        })
      }
      if (attachments.length > 1) {
        options.push({
          id: 'downloadAll',
          name: lang('dashboard_download_all'),
          onClick: () => onDownloadMultipleFiles({ urls: attachments.map(it => it.urlLong || it.url) })
        })
        options.push({
          id: 'downloadAllZip',
          name: lang('dashboard_download_all_zip'),
          onClick: () => onDownloadMultipleFilesToZip({ urls: attachments.map(it => it.urlLong || it.url) })
        })
      }
    }
    return options
  }

  const renderDotsMenu = () => {
    if (!node.isRemoved) {
      const options = getMenuSelectorOptions()
      if (options.length > 0) {
        return (
          <MenuDotsOptions
            typeOptions='dotsOptions'
            isOpen={isOpenMessageOptionsSelector}
            id={user._id}
            toggleDotsOptions={toggleDotsOptions}
            options={getMenuSelectorOptions()}
            className='newMenuHorizontalConversation'
            isOpenModalDelete={isOpenRemoveModal}
            toggleDelete={()=>setIsOpenRemoveModal(!isOpenRemoveModal)}
            type='message'
            eventDelete={()=>{
              handleDeleteMessage(node)
              setIsOpenRemoveModal(!isOpenRemoveModal)
            }}
          />
        )
      }
    }
  }

  return (
    <div id={node._id} className={`new-message ${node.type} ${!node?.text ? 'no-padding' : ''}`}>
      <div className='new-message__header-container'>
        <UserAvatar
          avatar={['customer_location', 'customer','customer_payment'].includes(node.type)
            ? user.avatarUrl
            : node.postedBy?.photoURL
          }
          channel={getChannelKey(user.channels[0].channel)}
          sentiment={{
            value: node.sentiment?.value,
            score: node.sentiment?.score,
            sentimentList: node.sentimentList
          }}
          onChangeSentiment={value => sentimentAPI.change({
            userId: user.id,
            nodeId: node._id,
            operatorId: operator._id,
            data: { sentiment: value }
          })}
          onErrorAvatar={event => {
            event.target.src = getStaticImage('/icons/orange-brand/icon-avatar.svg')
            event.onerror = null
          }}
        />
        <div className='new-message__header'>
          <strong>
            <DisplayNameMsg
              user={user}
              type={node.type.toLowerCase()}
              typeTitle={node.typeTitle}
              operatorName={node.postedBy && node.postedBy.name}
            />
          </strong>
        </div>
        {renderDotsMenu()}
      </div>
      <div className='new-message__body'>
        <div className={`new-message__content ${node.type}`}>
          {node.inReplyTo && (
            <InReplyTo
              messageSender={node.inReplyTo.type}
              text={node.isRemoved ? lang(`comment_${node.inReplyTo.messageContent.messageText}`) :node.inReplyTo.messageContent.messageText}
              attachments={node.inReplyTo.messageContent.attachments}
              postedBy={node.inReplyTo.postedBy}
              typeTitle={node.inReplyTo.typeTitle}
            />
          )}

          <div className='content'>
            {usersHelpers.showLinkMessages(node.messageContent.messageText) + getTextFromAudio(node.messageContent.attachments) && (
              <div style={{ padding: '10px 16px 0 10px' }}>
                <div
                  className={`wrapper-content-wall new-size-font ${node.isRemoved ? 'messageDelete' : ''}`}
                  dangerouslySetInnerHTML={{
                    __html: node.isRemoved
                      ? lang(node.type === 'note' ? 'note_deleted' : 'info_msg_was_deleted')
                      : usersHelpers.showLinkMessages(node.messageContent.messageText) + getTextFromAudio(node.messageContent.attachments),
                  }}
                />
              </div>
            )}
            {node.messageContent.buttons.length > 0 && !node.isRemoved && (
              <div
                className='message-buttons channels-normal'
                style={{ padding: '0px 12px 0px 12px' }}
              >
                {
                  node.messageContent.buttons.map((it, idx) => {
                    if(it.type === 'postback')
                      return(
                        <div
                          key={`${idx}`}
                          className={`message-buttons channels-normal`}
                          style={{
                            pointerEvents: 'none'
                          }}
                        >
                          <span key={idx}
                            className='chatmail-button text-ellipsis postback-disable'
                            rel='noopener noreferrer'
                          >
                            {it.label}
                          </span>
                        </div>
                      )
                    return (
                      <div
                        className={`new-size-font button-${node.messageContent.buttons.length}`}
                        key={idx}
                        dangerouslySetInnerHTML={{
                          __html: usersHelpers.showLinkMessages(it.content, it.label, user.provider_name),
                        }}
                      />
                    )
                  })
                }
              </div>
            )}
          </div>

          {/* Do not show nodes comments, likes, etc for ChatWeb */}
          {!notDiplayChild && (
            <ChatChannelWallMessagesPlugins user={user} node={node} paddingType={wallSettings.paddingType} />
          )}

          {/* Comments except for ChatWeb */}
          {!notDiplayChild && node.actionDetailList.map((nodeDetails, index) => (
            <div key={index} className={getCommentClassName(isShowComments, index, wallSettings)}>
              <ChatChannelWallActionDetail
                user={user}
                node={nodeDetails}
                wallSettings={wallSettings}
                id={node._id}
                index={index}
                isShowComments={isShowComments}
                getCommentClassName={getCommentClassName}
              />
            </div>
          ))}

          {/* Do not show nodes comments, likes, etc for chatweb */}
          {!notDiplayChild && (node.actionDetailList.length >= wallSettings.comments.limit || isShowLinkMoreComments) && (
            <div style={{ textAlign: 'center' }}>
              <p className={'show-comments'} onClick={() => setIsShowComments(!isShowComments)}>
                {lang(!isShowComments ? 'wall_showComments' : 'wall_hideComments')}
              </p>
            </div>
          )}
          <div className='new-message__footer'>
            {notDiplayChild && (
              <div className='new-message__date'>
                <span>
                  {getFormatedDate({ isoString: node.messageContent.createdAt, withTime: true, withYear: true })}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
      {!node.isRemoved && renderAttachments(node.messageContent.attachments)}
    </div>
  )
}

export default ChatChannelWallNodeInfo
